module.exports = __webpack_public_path__ + "img/1557614095884165122.e6ab02f1.png";